module.exports = __webpack_public_path__ + "img/logo.3a74ee6d.png";